import _ from "lodash";
import type {
    ConfigurableService,
    ResponsePackageItem,
    ServicioMegaMovil,
} from "../../../types/common";

interface HireMegaMovilConfig {
    limitToOne: boolean;
    showCurp: boolean;
    showBusinessFields: boolean;
    max: number;
    showLineTypeSelector: boolean;
    familyLineDefinitions: ServicioMegaMovil[];
}

const getConfiguredMaxQuantity = (config?: ConfigurableService): number => {
    const rawQuantity = config?.maxQuantity ?? config?.max_quantity ?? "0";
    const parsedQuantity = Number.parseInt(rawQuantity, 10);
    return Number.isNaN(parsedQuantity) ? 0 : parsedQuantity;
};

export const getHireMegaMovilConfig = (
    service: ResponsePackageItem,
    confServiceData: ConfigurableService[]
): HireMegaMovilConfig => {
    const getServiceConfig = (name: string) => (
        _.find<ConfigurableService>(confServiceData, (configItem) => configItem.name === name)
    );

    const enableResidencial = getServiceConfig(
        "ACTIVATE_MEGAMOVIL_RESIDENTIAL_DATA"
    )?.enabled;
    const enableBusiness = getServiceConfig(
        "ACTIVATE_MEGAMOVIL_BUSINESS_DATA"
    )?.enabled;
    const enableIndividual = getServiceConfig(
        "ACTIVATE_QTY_INDIVIDUAL_PLANS"
    )?.enabled;

    const maxResidential = getConfiguredMaxQuantity(getServiceConfig(
        "MAX_QUANTITY_INDIVIDUAL_RESIDENTIAL"
    ));
    const maxBusiness = getConfiguredMaxQuantity(getServiceConfig(
        "MAX_QUANTITY_INDIVIDUAL_BUSINESS"
    ));

    const isFamilyPackage = service.packageType === "FAMILIAR";
    const isIndividualPackage = service.packageType === "INDIVIDUAL";
    const limitToOne = Boolean(isFamilyPackage || (enableIndividual && isIndividualPackage));

    const showCurp = Boolean(enableResidencial && service.clasificacionMega === "RESIDENCIAL");
    const showBusinessFields = Boolean(enableBusiness && service.clasificacionMega === "EMPRESARIAL");

    const fallbackMax = service.clasificacionMega === "RESIDENCIAL" ? 10 : 50;
    const configuredMax = service.clasificacionMega === "RESIDENCIAL" ? maxResidential : maxBusiness;
    const max = limitToOne ? 1 : (configuredMax > 0 ? configuredMax : fallbackMax);

    return {
        limitToOne,
        showCurp,
        showBusinessFields,
        max,
        showLineTypeSelector: isFamilyPackage || isIndividualPackage,
        familyLineDefinitions: isFamilyPackage ? (service.servicios ?? []) : [],
    };
};
